module.exports = __webpack_public_path__ + "static/media/oktocash.e3c28ca6.png";